import { TABLE_DATA, TABLE_SCHEMA } from '@/main/store/listEditTypes';

import { INVENTORY_PARTS_DATA } from '../constants';

export const editMutations = <const>{
	PRACOVNIK_SELECT_MAPPER: 'pracovnikSelectMapper',
	ZAKAZNIK_SELECT_MAPPER: 'zakaznikSelectMapper',
	POJISTOVNA_SELECT_MAPPER: 'poistovnaSelectMapper',
	LEASING_SELECT_MAPPER: 'leasingSelectMapper',
};

export const UPDATE_TABLE_SCHEMA = 'UPDATE_TABLE_SCHEMA';
export const UPDATE_TABLE_DATA = 'UPDATE_TABLE_DATA';

export const listActions = <const>{
	InventoryPartsData_TABLE_SCHEMA: 'inventoryPartsDataTableSchema',
	InventoryPartsData_TABLE_DATA: 'inventoryPartsDataTableData',
};

// Typescript cannot correctly infer values of these expressions, even though they are const.
console.assert(`${INVENTORY_PARTS_DATA}_${TABLE_SCHEMA}` === 'InventoryPartsData_TABLE_SCHEMA');
console.assert(`${INVENTORY_PARTS_DATA}_${TABLE_DATA}` === 'InventoryPartsData_TABLE_DATA');
